import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { mountHelp } from "./helpWidget";

/**
 * Mounts Boona Help (see helpWidget.ts) in the current UI language. Renders
 * nothing itself: with `launcher` the widget brings its own floating button,
 * without it a button of ours calls openHelp().
 */
export function HelpLauncher({ source, launcher = true }: { source: "journal" | "inbox"; launcher?: boolean }) {
  const { i18n } = useTranslation();

  useEffect(() => {
    void mountHelp({ source, lang: i18n.language || "ru", launcher });
    // mounted once per app; the widget keeps its language until the next load
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}
